import React from 'react'

import UnidadComponentLoader from './UnidadComponentLoader'

const Mediacion = React.lazy(() => import('./mediacion/PagoFacturacion'))
const Correduria = React.lazy(() => import('./correduria/PagoFacturacion.js'))

export default function InfoPreliminar(params) {

    return (                     
        <UnidadComponentLoader 
            {...params}
            correduria={Correduria}
            mediacion={Mediacion}
        ></UnidadComponentLoader>       
    )

}